module.exports = {
	extends: [
		'/',
		'templates',
		'newsletter',
		'form',
		'form'
	],

	config: {
		preventMailingIDSelection: false,
		resourceConnected: false,
	},

	model: {
		grantedMailingListIDs: []
	},

	methods: {
		dataDealer: function(){
			var resourceData = this.getResourceRegisterContent('chooseMailingList') || {}
			this.config.preventMailingIDSelection = resourceData.preventMailingIDSelection || false;
			this.model.grantedMailingListIDs = resourceData.grantedMailingListIDs || [];
		}
	},

	hooks: {
		_attach: function($element, options){
			if(this.config.preventMailingIDSelection){
				$element.find('[data-field-code="mailingID"]').closest('.field').hide();
			}
			var $mailingListIDField = $element.find('[data-field-code="mailingListAndComponentID"]');
			if($mailingListIDField.length > 0){
				var ml, mailingListID;
				var grantedMailingListIDs = this.model.grantedMailingListIDs || [];
				var skipSelectingOnlyPossibility = grantedMailingListIDs.length === 1 && this.config.preventMailingIDSelection;
				if(grantedMailingListIDs.length > 0){
					$mailingListIDField.find('option').hide();

					for(ml in grantedMailingListIDs){
						mailingListID = this.model.grantedMailingListIDs[ml];
						if(mailingListID){
							var $option = $mailingListIDField.find(`option[value^="${mailingListID}_"]`);
							$option.show();
							if(skipSelectingOnlyPossibility){
								this.fieldToModel('mailingListAndComponentID', $option.attr('value'));
								this.closest('base_modal_modal', function(modal){
									modal.decide(true, this);
								});
							}
						}
					}
				}
			}
		}
	}
}